import { memo } from 'react';

const ContentWrapper = ({ children, title = '', thumb = '', classes = '' }) => (
	<div className="flex flex-col flex-1 overflow-hidden lg:w-0 lg:pl-88">
		<main className={`relative z-0 flex-1 overflow-y-auto min-h-screen-oly-mobile lg:min-h-screen-oly focus:outline-none print:min-h-0 ${classes}`}>
			{title && (
				<div className={`flex justify-center w-full px-3 py-3 lg:px-5 lg:py-4 ${thumb ? 'lg:bg-white lg:bg-opacity-60 lg:absolute' : ''}`}>
					<h1 className="lg:font-light text-[1.4375rem] lg:text-[1.875rem] text-oly-gray-darkest leading-10">
						{title}
					</h1>
				</div>
			)}
			{thumb && (
				<img src={`${process.env.REACT_APP_API_BASE_URL}/${thumb}`} alt={title} className="object-contain w-full lg:h-full lg:object-cover" />
			)}
			{children}
		</main>
	</div>
);

// TODO: Wann immer memo?
export default memo(ContentWrapper);
